export enum ETypePayment{
    creditCard = 'TCR',
    debitCard = 'TDB',
    cash = 'EFE',
    cheque = 'CHE'
}
